import "./Breadcrumb.scss";

import { getBoardTitle, getMeetingTitle, getPreferredName } from "helpers";
import { getApplicationName } from "models/Environment";
import { useBoard, useCustomParams, useMeeting, useTranslations } from "providers";
import { useEffect, useMemo } from "react";

export const DocumentTitles = () => {
  const i18n = useTranslations();
  const customParams = useCustomParams();
  const { board } = useBoard();
  const { meeting, meetingId } = useMeeting();

  const documentTitles = useMemo(() => {
    const documentTitles = [getApplicationName(i18n.ApplicationName)];

    const { isBoards, isMeetingParticipants, isMeetingAgendaItems, isMeetingDocuments, isMeetingOnedriveSync } =
      customParams;

    if (isBoards) {
      documentTitles.push(i18n.Boards);
    }

    if (board) {
      const name = getBoardTitle(i18n, getPreferredName(board));
      documentTitles.push(name);
    }

    if (meetingId && meeting) {
      const name = getMeetingTitle(meeting.title);
      documentTitles.push(name);
    }

    if (isMeetingAgendaItems) {
      documentTitles.push(i18n.Page_AgendaItems_Title);
    }

    if (isMeetingParticipants) {
      documentTitles.push(i18n.Page_Participants_Title);
    }

    if (isMeetingDocuments) {
      documentTitles.push(i18n.Page_Documents_Title);
    }

    if (isMeetingOnedriveSync) {
      documentTitles.push(i18n.Page_OneDriveSync_Title);
    }

    return documentTitles;
  }, [i18n, board, meeting, meetingId, customParams]);

  useEffect(() => {
    const titleToUse = documentTitles
      .reverse()
      .filter((x) => !!x)
      .join(" | ");

    document.title = titleToUse;
  }, [documentTitles]);

  return null;
};
